import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-ai-center p-jc-between" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hourglass-half" }),
    /*#__PURE__*/_createTextVNode(" Tempi ")
  ])
], -1)
const _hoisted_2 = { class: "two_col_layout" }
const _hoisted_3 = { class: "p-d-flex p-flex-column p-jc-center p-ai-center w100 p-py-5 p-py-sm-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "p-grid" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-col-2" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clock" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "p-col" }, " Preavviso: ")
], -1)
const _hoisted_5 = { class: "p-grid" }
const _hoisted_6 = { class: "p-col" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "p-grid" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-col-2" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hourglass-half" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "p-col" }, " ETA previsto ")
], -1)
const _hoisted_8 = { class: "p-grid p-mb-3" }
const _hoisted_9 = { class: "p-col p-text-nowrap" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "p-col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "p-grid" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-col-2" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-shipping-fast" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "p-col" }, " Tempo di viaggio ")
], -1)
const _hoisted_13 = { class: "p-grid" }
const _hoisted_14 = { class: "p-col" }
const _hoisted_15 = { class: "svg_container" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepDetails = _resolveComponent("StepDetails")!
  const _component_Button = _resolveComponent("Button")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("section", null, [
          _createVNode(_component_StepDetails, {
            date: _ctx.pickupDateTime,
            imagePath: _ctx.pickupImage,
            note: _ctx.pickupNote,
            time: _ctx.timePickup,
            title: "Ritiro"
          }, null, 8, ["date", "imagePath", "note", "time"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.creationExecutionDelta), 1)
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createTextVNode(_toDisplayString(_ctx.ETA || '--') + " ", 1),
              (_ctx.ETA != null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('common.minute', {count: _ctx.ETA})), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.KM || '-- Km') + " " + _toDisplayString(_ctx.$t('common.km')), 1)
          ]),
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.timeTravel), 1)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              disabled: !_ctx.hasSignature,
              icon: "fas fa-signature",
              label: "Vedi Firma",
              onClick: _ctx.toggleSignature
            }, null, 8, ["disabled", "onClick"]),
            _createVNode(_component_OverlayPanel, { ref: "signatureOP" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", {
                    innerHTML: _ctx.order.dropoff_signature
                  }, null, 8, _hoisted_16)
                ])
              ]),
              _: 1
            }, 512)
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_StepDetails, {
            date: _ctx.dropoffDateTime,
            imagePath: _ctx.dropoffImage,
            note: _ctx.dropoffNote,
            time: _ctx.timeDropoff,
            title: "Consegna"
          }, null, 8, ["date", "imagePath", "note", "time"])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("a", {
        href: _ctx.googleMapsUrl,
        target: "_blank"
      }, [
        _hoisted_18,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('order.preview_directions')), 1)
      ], 8, _hoisted_17)
    ]),
    _: 1
  }))
}